import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 025FEA9C-17F9-4293-BD59-A8D53B7B4124
 * name sack
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sack.svg
 * tags
 * - Gaming / RPG 
 */
export const SackIcon = createSvgIcon(<><path d="M16,9C20,11 21,18 21,18C21,18 22,22 16,22C10,22 8,22 8,22C2,22 3,18 3,18C3,18 4,11 8,9M14,4L12,2L10,4L6,2L8,7H16L18,2L14,4Z" /></>, 'SackIcon');
export default SackIcon